var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 108.44 122.88",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#95bf47", "fill-rule": "evenodd" },
        attrs: {
          d: "M95,23.66a1.2,1.2,0,0,0-1.08-1c-.45,0-9.19-.17-9.19-.17s-7.32-7.1-8-7.83A3,3,0,0,0,74,14.32l-3.68,1.14a25,25,0,0,0-1.76-4.32c-2.6-5-6.42-7.6-11-7.61h0c-.32,0-.64,0-1,.06-.14-.16-.27-.32-.42-.48A9.66,9.66,0,0,0,48.45,0c-6,.17-11.88,4.47-16.69,12.11a48,48,0,0,0-6.69,17.35L13.35,33.1c-3.45,1.08-3.56,1.19-4,4.44C9,40,0,109.8,0,109.8l75.65,13.08,32.79-8.15S95.06,24.28,95,23.66Zm-28.46-7-5.87,1.82A32.27,32.27,0,0,0,58.84,7.62c4.52.85,6.74,6,7.68,9Zm-9.83,3.05L44.06,23.59a30,30,0,0,1,6.38-12.38,12.7,12.7,0,0,1,4.29-3.12c1.65,3.43,2,8.3,2,11.59ZM48.58,4a6.09,6.09,0,0,1,3.58.94A17.17,17.17,0,0,0,47.54,8.5c-3.78,4.06-6.68,10.35-7.83,16.43L29.34,28.14C31.38,18.58,39.4,4.23,48.58,4Z",
          transform: "translate(0 0)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#5e8e3e", "fill-rule": "evenodd" },
        attrs: {
          d: "M93.9,22.66c-.45,0-9.19-.17-9.19-.17s-7.32-7.1-8-7.83a1.79,1.79,0,0,0-1-.47V122.87l32.78-8.15S95.05,24.28,95,23.66a1.17,1.17,0,0,0-1.07-1Z",
          transform: "translate(0 0)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#fff", "fill-rule": "evenodd" },
        attrs: {
          d: "M57.48,39.52,53.67,53.77a21.72,21.72,0,0,0-9.28-1.62c-7.38.47-7.46,5.12-7.39,6.29.4,6.37,17.16,7.76,18.11,22.69.74,11.74-6.23,19.77-16.27,20.41-12.05.76-18.69-6.35-18.69-6.35L22.7,84.33s6.68,5,12,4.7A4.72,4.72,0,0,0,39.33,84c-.52-8.31-14.18-7.82-15-21.48C23.56,51,31.11,39.34,47.77,38.29c6.43-.41,9.71,1.23,9.71,1.23Z",
          transform: "translate(0 0)",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }